import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5xdelgfsdc: FaireBrandEntity = {
  token: "b_5xdelgfsdc",
  type: "brand",
  name: "Gypsy Rose",
  avatarUrl:
    "https://cdn.faire.com/fastly/6b7a6709a355211c64e796ff85938701d5e6a5911cf924880bf839f6e31e5709.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/eaa2c549a7753e7338cb8e0745120e4687c2340466a392b8eb86f9e2ddadf009.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6b7a6709a355211c64e796ff85938701d5e6a5911cf924880bf839f6e31e5709.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/eaa2c549a7753e7338cb8e0745120e4687c2340466a392b8eb86f9e2ddadf009.jpeg",
  location: "Warminster, PA, USA",
  minimumOrderDollars: 208,
  rating: 4.8,
  reviewCount: 617,
  isTopShop: true,
  isInsider: true,
  description:
    "For more than 30 years, Gypsy Rose has been weaving peace, love, and that good ol’ hippie vibe throughout the world. We are suppliers of kind goods, many made by cottage industries and family businesses across the globe, for kind people who share our love of this peaceful hippie mindset. No matter what your style, from vintage and boho to trendy and funky, we have the gear to suit your perfectly unique style! In the Gypsy Rose world we balance the funny, freaky, witty & wacky with a commitment to the more serious issues that face us. We are sensitive to the communities in the countries where our products are produced. Gypsy Rose exists to keep the peaceful hippie vibe alive through our one-of-a-kind products and to spread the word about the issues that mean so much to us. So we like to help out our planet & our fellow human beings but at the same time we like to have a lot of fun doing so. We hope that you’ll come and join together with us. There’s plenty of room!",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:48.915Z",
    importedBy: "entity-db-cli",
  },
};
